(function () {
    'use strict';

    // A convenience file for the server to pull in all the strings in on shot
    if (typeof window === 'undefined') {
        const _ = require('lodash');

        module.exports = _.extend({},
            require('./rivaliq.js'),
            require('./facebookInsightsPosts.js')
        );
    }

    // NOTE: noop on client

})();
